export default function getViewIndex(view) {
  let importFile = view.flow
    ? 'flow'
    : view.query
    ? 'data'
    : view.logic
    ? 'logic'
    : 'view'

  return `// This file is autogenerated.
// It's the entrypoint to the view, hiding away the fact
// that it may just be the view or have a wrapper like
// a logic, data, or flow file.
//
// The import file hierarchy is:
// - flow.js
//   - data.js
//     - logic.js
//       - view.js

import ${view.id} from './${importFile}'
export default ${view.id}
`
}
